import { AddOnCreationDTO, AddOnDTO, AddOnUpdateDTO, findAllAddOnsFiltersDTO, findAllAddOnsResponseDTO } from "./dto"
import { AddOnServiceImpl } from "./serviceImpl"


export interface AddOnService {
    getAddOns(filters: findAllAddOnsFiltersDTO): Promise<findAllAddOnsResponseDTO>
    getAddOnById(id: string): Promise<AddOnDTO>
    updateAddOn(id: string, data: AddOnUpdateDTO): Promise<void>
    createAddOn(data: AddOnCreationDTO): Promise<number>
    deleteAddOn(id: string): Promise<void>
}

export function NewAddOnService(): AddOnService {
    return new AddOnServiceImpl();
}
